import { getId } from '../../utils/helperMethods';
import {
    FormElems,
    AlertModal,
    QRCodeWithCopyDownload,
} from '../../components/';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { last } from 'lodash';
import AddRole from './AddRole';
import './TerminalTab.scss';
import Tooltip from 'rc-tooltip';
import infoIcon from '../../static/images/blackinfo.png';
import { ENTITY_TYPE } from '../../utils/constants/commonValues';
import {
    getMerchantInfoRequest,
    addTIDMakerRequest,
    getTerminalInfoRequest,
    fetchEntityHierarchyRequest,
    resetTerminalData,
    fetchStaticURL,
    resetMerchantData,
    resetHList,
    fetchEntityHierarchySuccess,
    fetchEntityListRequest,
} from '../../containers/TerminalOnboard/redux/TIDOnBoard.actions';
import validate from './validator';
import { getRollList, maskAccountNumber } from './helper';
import { roleList, initialStatusOptions } from './constants';

const TerminalTab = ({
    handleSubmit,
    history,
    actions,
    auth,
    editData,
    formData,
    change,
    terminalsData,
}) => {
    const { location } = history;
    const terminalId = last(location.pathname.split('/'));
    const isEditMode = location.pathname.includes('edit');
    const isViewMode = location.pathname.includes('view');
    const {
        tidEditData,
        tidError,
        hList,
        entityList,
        hierarchyLoader,
    } = terminalsData;

    const { userDetails } = auth;
    const [roleList, setRoleList] = useState([]);
    const [merchantError, setMerchantError] = useState(null);
    const [entitySelectedValue, setEntitySelectedValue] = useState({});
    const [isChange, setIsChange] = useState(false);
    const [preTerminalData, setPreTerminalData] = useState({});
    const [isUpdateAllowed, setIsUpdateAllowed] = useState(false);
    const [accounsList, setAccountsList] = useState([]);
    const [statusOptions, setStatusOptions] = useState(initialStatusOptions);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [merchantStatus, setMerchantStatus] = useState(null);
    useEffect(() => {
        if (isEditMode && formData && formData.values) {
            const values = formData.values;
            if (
                values.terminalName !== preTerminalData.terminalName ||
                values.status !== preTerminalData.terminalStatus ||
                values.email !== preTerminalData.email ||
                values.settlementAccountRefence !==
                    preTerminalData.settlementAccountRefence
            ) {
                setIsUpdateAllowed(true);
            } else {
                setIsUpdateAllowed(false);
            }
        }
    }, [formData, preTerminalData, isEditMode]);

    const handleRoleSelect = (value, originalData, type) => {
        actions.fetchEntityHierarchyRequest(value, originalData.entityType);
        if (type === 'MERCHANT') {
            actions.getMerchantInfoRequest(value, [], history, toast);
            setMerchantError(null);
        }
    };

    useEffect(() => {
        if (terminalsData.merchant && terminalsData.merchant.settlementDataSection) {
            const accountNumbers =
                terminalsData.merchant.settlementDataSection.accountDetails;
            const maskedAccountNumbers = accountNumbers.map(account => {
                return {
                    name: maskAccountNumber(account.accountNumber),
                    value: account.accountNumber,
                };
            });
            setAccountsList(maskedAccountNumbers);
            // DEFEULT ACCOUNT SELECTION ON CREATE MODE
            if (!isViewMode && !isEditMode) {
                change(
                    'settlementAccountRefence',
                    accountNumbers[0].accountNumber
                );
            }
        } else {
            setAccountsList([]);
        }

        if (terminalsData.merchant && terminalsData.merchant.entityDetails.paymentCategory) {
            const payment =
                terminalsData.merchant.entityDetails.paymentCategory;
            change('entityStatus', payment);
        }

        if (terminalsData.merchant &&
            terminalsData.merchant.integrationData &&
            terminalsData.merchant.paymentModeData &&
            terminalsData.merchant.entityDetails &&
            !isViewMode
        ) {
            const isStaticQREnabled =
                terminalsData.merchant.integrationData.isStaticQREnabled;
            const status = terminalsData.merchant.entityDetails.status;
            const paymentModeDetails =
                terminalsData.merchant.paymentModeData.paymentModeDetails;
            let isUPI = false;
            paymentModeDetails.forEach(payment => {
                if (payment.paymentType === 'UPI') {
                    isUPI = true;
                }
            });
            setMerchantStatus(status);
            if (!isStaticQREnabled) {
                setIsAlert(true);
                setAlertMessage(
                    isEditMode
                        ? 'Static QR is disabled for this merchant. Unable to proceed with terminal updation.'
                    : 'Static QR is disabled for this merchant. Unable to proceed with terminal creation.'
                );
            } else if (status === 2) {
                setIsAlert(true);
                setAlertMessage(
                    isEditMode
                        ? 'Merchant is inactive. Unable to proceed with terminal updation.'
                        : 'Merchant is inactive. Unable to proceed with terminal creation.'
                );
            } else if (!isUPI) {
                setIsAlert(true);
                setAlertMessage(
                    isEditMode
                        ? 'UPI payment mode is not enabled for this merchant. Unable to proceed with terminal updation.'
                    : 'UPI payment mode is not enabled for this merchant. Unable to proceed with terminal creation.'
                );
            }
        }
    }, [isEditMode, isViewMode, terminalsData.merchant]);

    useEffect(() => {
        actions.fetchEntityListRequest(ENTITY_TYPE.AGGREGATOR);
        actions.fetchEntityListRequest(ENTITY_TYPE.FRANCHISE);
        actions.fetchEntityListRequest(ENTITY_TYPE.MLE);
        actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT);
    }, [actions]);

    const handleFormSubmit = values => {
        const request = {
            aggregator: terminalsData.hList.agr,
            mle: terminalsData.hList.mle,
            merchantId: terminalsData.hList.mid,
            franchise: terminalsData.hList.fra,
            terminalName: values.terminalName,
            terminalCount:
                values.terminalCount && values.bulkGenerate === 'enable'
                    ? parseInt(values.terminalCount)
                    : 1,
            paymentMode: values.paymentCategory,
            settlementAccountRefence: values.settlementAccountRefence,
            status: values.status === undefined ? 1 : values.status,
            paymentCategory: values.entityStatus,
            eventType: isEditMode
                ? 'TERMINAL_ID_UPDATE'
                : 'TERMINAL_ID_ONBOARD',
            idempotencyId: isEditMode
                ? tidEditData.entityDetails.entityCode
                : terminalsData.hList.mid,
            email: values.email,
            staticQr: null,
            terminalVpa: null,
        };

        if (values.bulkGenerate === 'enable') {
            delete request.email;
        }

        if (isEditMode) {
            request.terminalCode = tidEditData.entityDetails.entityCode;
            delete request.staticQr;
            delete request.terminalVpa;
        }

        if (isViewMode) {
            history.push('/tid-onboarding');
        } else {
            actions.addTIDMakerRequest(
                request,
                history,
                toast,
                userDetails.email
            );
        }
    };

    useEffect(() => {
        if (
            (isEditMode || isViewMode) &&
            tidEditData &&
            tidEditData.linkedEntityInfoList &&
            tidEditData.linkedEntityInfoList.length > 0
        ) {
            const jsonResponse = tidEditData.linkedEntityInfoList[0];
            const entityCode = jsonResponse.merchantDetails.entityCode;
            const name = jsonResponse.merchantDetails.name;
            setRoleList(getRollList(entityList, hList, { entityCode, name }));
        } else {
            setRoleList(getRollList(entityList, hList));
        }
    }, [hList, entityList, tidEditData, isEditMode, isViewMode]);

    useEffect(() => {
        if (entitySelectedValue.merchant) {
            const merchantId = entitySelectedValue.merchant;
            actions.getMerchantInfoRequest(merchantId, [], history, toast);
        }
    }, [actions, entitySelectedValue, history]);

    useEffect(() => {
        if (terminalId && (isViewMode || isEditMode)) {
            actions.getTerminalInfoRequest(terminalId, history, toast);
        }
    }, [terminalId, isEditMode, isViewMode, actions, history]);

    useEffect(() => {
        if (
            tidEditData &&
            tidEditData.linkedEntityInfoList &&
            tidEditData.linkedEntityInfoList.length > 0 &&
            (isViewMode || isEditMode)
        ) {
            const terminalStatus = tidEditData.entityDetails.status;
            const terminalName = tidEditData.entityDetails.name;
            const jsonResponse = tidEditData.linkedEntityInfoList[0];
            const entityCode = jsonResponse.merchantDetails.entityCode;
            const email = tidEditData.entityDetails.email;
            const paymentCategory =
                jsonResponse.merchantDetails.paymentCategory;

            if (terminalStatus === 5) {
                setStatusOptions(preState => {
                    const newState = [...preState];
                    newState[2] = {
                        name: 'Inactive With Settlement',
                        value: 5,
                    };
                    return newState;
                });
            }

            let accountNumber = '';

            if (tidEditData.terminalIdInfo && tidEditData.terminalIdInfo.parentSettlementAccountNumber) {
                accountNumber =
                    tidEditData.terminalIdInfo.parentSettlementAccountNumber;
                change('settlementAccountRefence', accountNumber);
            }

            change('entityStatus', paymentCategory);
            change('status', terminalStatus);
            change('email', email);
            change('terminalName', terminalName);
            change('formType', 'UPDATE');
            actions.fetchEntityHierarchyRequest(entityCode, 'MERCHANT');
            actions.getMerchantInfoRequest(entityCode, [], history, toast);
            setPreTerminalData({
                terminalStatus,
                terminalName,
                email,
                settlementAccountRefence: accountNumber,
            });
        }
    }, [tidEditData, actions, isViewMode, isEditMode, history]);

    useEffect(() => {
        const paymentMode = 'UPI';
        change('paymentCategory', paymentMode);
    }, []);

    useEffect(() => {
        return () => {
            actions.resetTerminalData();
            actions.resetMerchantData();
            actions.resetHList();
        };
    }, [actions, history.pathname]);

    useEffect(() => {
        if (tidEditData && tidEditData.linkedEntityInfoList) {
            const jsonResponse = tidEditData?.linkedEntityInfoList[0];
            const paymentCategory =
                jsonResponse?.merchantDetails?.paymentCategory;
            const entityCode = tidEditData.entityDetails.entityCode;
            actions.fetchStaticURL(entityCode);
        }
    }, [actions, tidEditData]);

    const handleResetSection = type => {
        if (type === 'AGGREGATOR') {
            const newHlist = { ...hList };
            delete newHlist.agr;
            actions.fetchEntityHierarchySuccess(newHlist);
        } else if (type === 'FRANCHISE') {
            const newHlist = { ...hList };
            delete newHlist.fra;
            actions.fetchEntityHierarchySuccess(newHlist);
        } else if (type === 'MLE') {
            const newHlist = { ...hList };
            delete newHlist.mle;
            actions.fetchEntityHierarchySuccess(newHlist);
        } else if (type === 'MERCHANT') {
            const newHlist = { ...hList };
            delete newHlist.mid;
            actions.fetchEntityHierarchySuccess(newHlist);
            actions.resetMerchantData();
        }
    };

    const handleSubmitClick = event => {
        if (!terminalsData.hList.mid) {
            return setMerchantError('Please select merchant.');
        }
    };

    const handleSearchEnd = (value, entityType) => {
        const type = entityType.toUpperCase();

        const filtered =
            entityList[type.toLowerCase()]?.filter(item => {
                const key = 'entityCode';
                return item[key]?.toLowerCase().includes(value.toLowerCase());
            }) || [];

        const data = {
            entityName: value,
            entityCode: '',
        };

        if (filtered.length === 0 && value.length >= 3) {
            actions.fetchEntityListRequest(entityType, data);
        }
    };

    const handleAlertOk = () => {
        setAlertMessage('');
        setIsAlert(false);
        if (isEditMode) {
            history.push('/tid-onboarding');
        }

        if (!isEditMode) {
            const newHlist = { ...hList };
            delete newHlist.mid;
            actions.fetchEntityHierarchySuccess(newHlist);
            actions.resetMerchantData();
        }
    };

    const checkIsEnabled = () => {
        if (!formData || !formData.values) {
            return false;
        }
        const values = formData.values;
        return values.terminalName &&
            values.settlementAccountRefence &&
            values.paymentCategory &&
            terminalsData &&
            terminalsData.hList.mid &&
           (values.bulkGenerate === 'enable'
            ? values.terminalCount && values.terminalCount > 0
            : true);
    };

    return (
        <div className="merchant-tab">
            <AlertModal
                modalIsOpen={isAlert}
                primaryButtonText="OK"
                showActions={true}
                onSuccessModal={handleAlertOk}
                headerText="Alert"
                message={alertMessage}
            />
            <form
                className="merchant-detail-form"
                onSubmit={handleSubmit(handleFormSubmit)}
            >
                <div className="merchant-details card merchant-boarding">
                    <h2 className="tab-title">Terminal ID Details</h2>
                    <ul className="form-list">
                        <>
                            <li className="form-section">
                                {roleList.slice(0, 3).map(item => (
                                    <AddRole
                                        key={getId(item.name)}
                                        id={getId(item.name)}
                                        hierarchyLoader={hierarchyLoader}
                                        data={item}
                                        entitySelectedValue={item.selected}
                                        setEntityValues={values =>
                                            setEntitySelectedValue(values)
                                        }
                                        onRoleSelect={handleRoleSelect}
                                        isViewMode={isViewMode || isEditMode}
                                        handleResetSection={handleResetSection}
                                        handleSearchEnd={handleSearchEnd}
                                    />
                                ))}
                            </li>
                            <li className="form-section">
                                {roleList.slice(3).map(item => (
                                    <AddRole
                                        key={getId(item.name)}
                                        id={getId(item.name)}
                                        hierarchyLoader={hierarchyLoader}
                                        data={item}
                                        entitySelectedValue={item.selected}
                                        onRoleSelect={handleRoleSelect}
                                        isViewMode={isViewMode || isEditMode}
                                        handleResetSection={handleResetSection}
                                        error={merchantError}
                                        handleSearchEnd={handleSearchEnd}
                                    />
                                ))}
                                <div className="form-field">
                                    <p className="label">Settlement Account</p>
                                    <Field
                                        name="settlementAccountRefence"
                                        placeholder="Settlement Account"
                                        id="settlementAccountRefence"
                                        data={accounsList}
                                        labelField="name"
                                        valueField="value"
                                        component={FormElems.Select}
                                        label="Select Settlement Account"
                                        disabled={
                                            isViewMode ||
                                            !terminalsData.merchant
                                        }
                                    />
                                </div>

                                <div className="form-field">
                                    {formData?.values?.bulkGenerate !==
                                    'enable' ? (
                                        <React.Fragment>
                                            <p className="label">
                                                Email
                                                {!isEditMode && !isViewMode && (
                                                    <span
                                                        className={
                                                            'field-bottom-message optional'
                                                        }
                                                    >
                                                        (Optional)
                                                    </span>
                                                )}
                                            </p>
                                            <Field
                                                name="email"
                                                type="text"
                                                id="email"
                                                component={FormElems.Input}
                                                placeholder="Enter Email"
                                                disabled={isViewMode}
                                            />
                                        </React.Fragment>
                                    ) : null}
                                </div>
                            </li>
                        </>

                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Merchant Category</p>
                                <Field
                                    name="entityStatus"
                                    component={FormElems.Radio}
                                    labelField="name"
                                    wrapperClass="wrap-checkbox"
                                    options={[
                                        {
                                            name: 'Online',
                                            value: 'Online',
                                        },
                                        {
                                            name: 'Offline',
                                            value: 'Offline',
                                        },
                                    ]}
                                    valueField="value"
                                    disabled={true}
                                />
                            </div>
                            <div className="form-field">
                                {!isEditMode && !isViewMode ? (
                                    <>
                                        <p className="label">Bulk Generate</p>
                                        <Field
                                            name="bulkGenerate"
                                            component={FormElems.Radio}
                                            labelField="name"
                                            wrapperClass="wrap-checkbox"
                                            defaultSelected={'disable'}
                                            options={[
                                                {
                                                    name: 'Enable',
                                                    value: 'enable',
                                                },
                                                {
                                                    name: 'Disable',
                                                    value: 'disable',
                                                },
                                            ]}
                                            valueField="value"
                                            disabled={isViewMode}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <p className="label">Status</p>
                                        <Field
                                            name="status"
                                            component={FormElems.Radio}
                                            labelField="name"
                                            wrapperClass="wrap-checkbox custom-radio"
                                            options={statusOptions}
                                            valueField="value"
                                            disabled={
                                                isViewMode ||
                                                merchantStatus != 1
                                            }
                                        />
                                    </>
                                )}
                            </div>
                            <div className="form-field checkbox-wrap dummy-field" />
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                {formData?.values?.bulkGenerate === 'enable' ? (
                                    <div className={'custom-terminal-label'}>
                                        <p className="label">Terminal Name</p>
                                        <Tooltip
                                            overlayStyle={{ width: '300px ' }}
                                            placement="top"
                                            overlay={
                                                'The terminal name will be used as a prefix during bulk creation. For example, if the terminal name is "ABC" and 50 TIDs are being created, the names will be generated as ABC1, ABC2, ABC3, ... ABC50.'
                                            }
                                        >
                                            <img src={infoIcon} alt={`info`} />
                                        </Tooltip>
                                    </div>
                                ) : (
                                    <p className="label">Terminal Name</p>
                                )}

                                <Field
                                    name="terminalName"
                                    type="text"
                                    id="refund-terminalName"
                                    component={FormElems.Input}
                                    placeholder="Enter Terminal Name"
                                    disabled={isViewMode}
                                />
                                <p className={'field-bottom-message'}>
                                    Terminal name can only be{' '}
                                    <span>alphanumeric</span> and must be below{' '}
                                    <span> 90 characters</span>.
                                </p>
                            </div>
                            <div className="form-field">
                                <p className="label">Payment Mode</p>
                                <Field
                                    name="paymentCategory"
                                    placeholder="Payment Mode"
                                    id="state"
                                    data={[
                                        {
                                            name: 'UPI',
                                            value: 'UPI',
                                        },
                                    ]}
                                    defaultSelected={'UPI'}
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    label="Select Payment Mode"
                                    disabled={true}
                                />
                            </div>
                            <div className="form-field">
                                {formData?.values?.bulkGenerate === 'enable' &&
                                    !isEditMode &&
                                    !isViewMode && (
                                        <>
                                            <p className="label">
                                                TID Count (Max Count 100000)
                                            </p>
                                            <Field
                                                name="terminalCount"
                                                type="number"
                                                id="refund-terminalCount"
                                                component={FormElems.Input}
                                                placeholder="Enter TID Count"
                                                disabled={isViewMode}
                                            />
                                        </>
                                    )}
                            </div>
                        </li>
                        <li className="form-section">
                            {terminalsData.staticQr?.staticQrString && (
                                <div
                                    className="form-field"
                                    style={{
                                        width: '400px',
                                        marginTop: '30px',
                                    }}
                                >
                                    <p className="label">Static QR</p>
                                    <QRCodeWithCopyDownload
                                        qr={
                                            terminalsData.staticQr
                                                .staticQrString
                                        }
                                        text={
                                            tidEditData.entityDetails
                                                .subMerchantVpa
                                        }
                                    />
                                </div>
                            )}

                            <div className="form-field" />
                            <div className="form-field" />
                        </li>
                    </ul>
                </div>

                <div className="form-section action">
                    <FormElems.Button
                        id="next-btn"
                        buttonType={
                            (isEditMode && isUpdateAllowed) || checkIsEnabled()
                                ? 'primary'
                                : 'secondary'
                        }
                        text={
                            isViewMode
                                ? 'Close'
                                : isEditMode
                                    ? 'Update'
                                    : 'Submit'
                        }
                        handleClick={handleSubmitClick}
                        isDisable={(isEditMode && !isUpdateAllowed) || !checkIsEnabled()}
                    />
                </div>
            </form>
        </div>
    );
};

TerminalTab.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    change: PropTypes.func,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    formData: PropTypes.object,
};

const mapStateToProps = ({ auth, form, editData, terminalsData }) => ({
    auth,
    formData: form['add-tid-form'],
    editData,
    terminalsData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchEntityHierarchyRequest,
            fetchEntityListRequest,
            getMerchantInfoRequest,
            addTIDMakerRequest,
            getTerminalInfoRequest,
            resetTerminalData,
            fetchStaticURL,
            resetMerchantData,
            resetHList,
            change,
            fetchEntityHierarchySuccess,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'add-tid-form',
            enableReinitialize: true,
            validate,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(TerminalTab)
);
